'use es6';

import { FetchRequiredOnboardingRequestTypes } from '../actions/RequiredOnboardingActions';

const RequiredOnboarding = (state = {}, {
  type,
  payload
}) => {
  switch (type) {
    case FetchRequiredOnboardingRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data && data.requiredOnboarding;
      }

    default:
      return state;
  }
};

export default RequiredOnboarding;